export default function getCurrentSiteName() {
  return window.location.pathname.split('/')[1];
}
